export const aboutData = {
  brandName: '秘密教学',
  tagline: '解锁隐藏知识的高效学习法',
  intro: '秘密教学诞生于一个简单的信念：最好的学习方法，往往不在教科书里。我们是一个由认知科学家、教育研究者和资深学习者组成的团队，致力于挖掘和传播那些被主流教育体系忽视但经科学研究证明极其有效的学习方法。',
  mission: '我们的使命是让每一位学习者都能掌握科学的、高效的学习方法，不再被低效的学习习惯所束缚。我们相信，学习能力是21世纪最重要的核心竞争力，而这项能力本身是可以被学习和提升的。',
  vision: '我们致力于打造全球最权威的中文学习方法论平台，让每一位渴望成长的人都能找到适合自己的学习路径，实现知识获取的质的飞跃。',
  stats: [
    { value: '50万+', label: '月均读者' },
    { value: '120+', label: '深度文章' },
    { value: '8年', label: '研究积累' },
    { value: '98%', label: '读者好评率' }
  ],
  team: [
    {
      name: '林启明',
      role: '创始人 & 主笔',
      bio: '认知心理学硕士，十年教育研究经验，专注于学习科学和方法论研究',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20portrait%20of%20Asian%20man%20in%20his%2030s%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20intellectual%20vibe%2C%20clean%20editorial%20style%2C%20no%20text&width=400&height=400&seq=team-1&orientation=squarish'
    },
    {
      name: '陈思涵',
      role: '联合创始人 & 研究总监',
      bio: '教育技术学博士，专注于将认知科学成果转化为实用学习方法',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20portrait%20of%20Asian%20woman%20in%20her%2030s%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20intellectual%20style%2C%20clean%20editorial%20portrait%2C%20no%20text&width=400&height=400&seq=team-2&orientation=squarish'
    },
    {
      name: '王浩然',
      role: '资深编辑',
      bio: '前主流媒体教育版主编，擅长将复杂的学术研究转化为通俗易懂的内容',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20portrait%20of%20Asian%20man%20in%20his%2040s%2C%20warm%20natural%20lighting%2C%20minimalist%20cream%20background%2C%20editorial%20style%2C%20clean%20portrait%2C%20no%20text&width=400&height=400&seq=team-3&orientation=squarish'
    }
  ],
  testimonials: [
    {
      name: '李同学',
      role: '清华大学研究生',
      content: '秘密教学彻底改变了我的学习方式。以前我靠死记硬背，效率低而且容易忘。学了主动回忆和间隔重复后，我的学习效率至少提升了两倍，GRE成绩从310提升到了332。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20portrait%20of%20young%20Asian%20student%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20no%20text&width=200&height=200&seq=test-1&orientation=squarish'
    },
    {
      name: '张女士',
      role: '互联网公司产品总监',
      content: '作为职场人，最宝贵的就是时间。秘密教学的方法让我在繁忙的工作中依然能高效学习新技能。特别是思维模型那一套，直接改变了我的决策方式。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20portrait%20of%20professional%20Asian%20woman%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20no%20text&width=200&height=200&seq=test-2&orientation=squarish'
    },
    {
      name: '赵老师',
      role: '中学特级教师',
      content: '我把秘密教学的方法引入课堂后，学生的成绩和学习积极性都有了显著提升。费曼技巧和康奈尔笔记法尤其受学生欢迎，他们说"原来学习可以这么清晰"。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20portrait%20of%20teacher%20Asian%20man%20in%20his%2040s%2C%20warm%20natural%20lighting%2C%20clean%20cream%20background%2C%20editorial%20style%2C%20no%20text&width=200&height=200&seq=test-3&orientation=squarish'
    }
  ],
  media: [
    { name: '得到APP', type: '知识服务平台' },
    { name: '三联生活周刊', type: '知名媒体' },
    { name: '网易公开课', type: '在线教育平台' },
    { name: '知乎', type: '知识分享社区' },
    { name: '豆瓣', type: '文化社区' },
    { name: 'B站', type: '视频平台' }
  ]
};

export const contactInfo = {
  email: 'contact@mimijiaoxue.com',
  address: '北京市海淀区中关村大街1号',
  wechat: 'mimijiaoxue_official',
  weibo: '@秘密教学官微'
};